import RootModel from './root';

const User = new RootModel({
	path: 'users',
});

export default User;
